#import "@core/schema/fragments/CustomerFull.graphql"

query {
  getMe {
    customer {
      ...CustomerFull
    }
    b2bPricingLevelSecretKey
  }
}
